/* eslint-disable @typescript-eslint/no-explicit-any */

type BreadcrumbListItem = {
  name?: string | null
}

const normalizeDyLabel = (value: string) =>
  value
    .trim()
    .replace(/[-_]+/g, ' ')
    .replace(/\s+/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase())

const isValidDySegment = (value: unknown): value is string => {
  if (typeof value !== 'string') {
    return false
  }

  const trimmedValue = value.trim()

  if (trimmedValue.length === 0) {
    return false
  }

  const lowerValue = trimmedValue.toLowerCase()

  return (
    !trimmedValue.includes('[') &&
    !trimmedValue.includes(']') &&
    lowerValue !== 'homepage' &&
    lowerValue !== 'home'
  )
}

export const getDynamicYieldProductSku = (props: any): string | null => {
  // Le pagine Gatsby espongono i dati prodotto in punti diversi a seconda della
  // sorgente SSR/client. Proviamo tutte le posizioni note prima di dare a DY
  // uno SKU vuoto.
  const product =
    props?.serverData?.product ??
    props?.data?.product ??
    props?.pageContext?.product ??
    null

  const offer = product?.offers?.offers?.[0]
  const itemOffered = offer?.itemOffered

  return (
    product?.sku ??
    product?.productID ??
    product?.gtin ??
    product?.id ??
    offer?.sku ??
    offer?.gtin ??
    itemOffered?.sku ??
    itemOffered?.gtin ??
    null
  )
}

export const getDynamicYieldCategoryPath = (
  props: any,
  pathname: string
): string[] => {
  const isProductPage = pathname.endsWith('/p')

  if (isProductPage) {
    // Il context PDP dovrebbe includere anche il category path del prodotto.
    // Preferiamo il breadcrumb prodotto perche' e' piu' semantico degli URL.
    const breadcrumbItems: BreadcrumbListItem[] =
      props?.serverData?.product?.breadcrumbList?.itemListElement ??
      props?.data?.product?.breadcrumbList?.itemListElement ??
      props?.pageContext?.product?.breadcrumbList?.itemListElement ??
      []

    const names = breadcrumbItems
      .map((item) => item?.name)
      .filter(isValidDySegment)

    if (names.length > 1) {
      // L'ultimo breadcrumb di solito e' il prodotto stesso, quindi lo togliamo
      // prima di passare a DY i dati categoria.
      return names.slice(0, -1).map(normalizeDyLabel)
    }

    return pathname
      .split('/')
      .filter(Boolean)
      .filter((segment) => !segment.includes('[') && !segment.includes(']'))
      .slice(0, -1)
      .map(normalizeDyLabel)
  }

  return pathname
    .split('/')
    .filter(Boolean)
    .filter((segment) => !segment.includes('[') && !segment.includes(']'))
    .map(normalizeDyLabel)
}
